<!--
 * @Description: wap app.vue
 * @Author: Rfan
 * @Date: 2020-01-14 11:45:20
 * @LastEditTime: 2025-07-08 18:09:11
--> 
<template>
  <div id="app" oncontextmenu="self.event.returnValue=false">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" ref="view" :key="key"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" ref="view" :key="key"></router-view>
    <!-- <router-view /> -->
    <!-- <keep-alive :include="cachedViews">
      <router-view :key="key" />
    </keep-alive> -->
  </div>
</template>

<script>
import {
  getUserInfo,
  getAppVerInfo,
  setupWebViewJavascriptBridge,
  getBindInfo,

  installNewBrushSuccess,
  loginSuccess
} from "@/assets/js/client.js";
import { testPlatform } from "@/utils";

export default {
  name: "app",
  data() {
    return {
      loadCount: 0,
    };
  },
  computed: {
    // key() {
    //   return this.$route.name + new Date().getTime();
    // },
    key() {
      return this.$route.path;
    }
  },
  created() {
    setTimeout(() => {
      getBindInfo();
    }, 200);
    const that = this;
    this.fetchInfoFromAPP();
    window.addEventListener('windowsHsjproChange', () => {
      if (window.windowsHsjpro) {
        that.windowsMethod();

        window.windowsHsjpro.installBrushesSuccess.connect(function(result) {
          installNewBrushSuccess(JSON.stringify(result));
        });
        window.windowsHsjpro.loginSuccess.connect(function(result){
          loginSuccess(result);
        });
      }
    });
  },
  methods: {
    fetchInfoFromAPP() {
      let that = this;

      this.windowsMethod();

      if (testPlatform("ios")) {
        setupWebViewJavascriptBridge(function (bridge) {
          bridge.callHandler("getCurrentUserToken", null, function (data) {
            that.$store.commit("setMemberInfo", data);
            that.$store.commit("setQuery", data);
            console.log("app memberinfo", data);
            getBindInfo();
          });
          bridge.callHandler("getAppVer", null, function (data) {
            that.$store.commit("setVer", data);
            try {
              console.log("app ver", data, parseInt(data.replace(/\./g, "")));
            } catch (err) {
              console.log(err);
            }
          });
        });
      } else {
        this.androidMethod();
      }
    },
    windowsMethod() {
      const that = this;
      if (window.windowsHsjpro) {
          if (window.windowsHsjpro.getAppInfo) {
            window.windowsHsjpro.getAppInfo().then(res => {
              console.log('getAppInfo', res);
              const dic = this.$store.getters.getMemberInfo;
              that.$store.commit('setMemberInfo', { ...dic, ...res });
              that.$store.commit('setQuery', res);
              console.log('app memberinfo', JSON.stringify(res));
              const versionDic = {
                verCode: res.version_code,
                verName: res.version_name
              };
              this.$store.commit('setVer', { ver: versionDic, verName: versionDic.verName });
            });
          }
          if (window.windowsHsjpro.getUserInfo) {
            window.windowsHsjpro.getUserInfo().then(res => {
              console.log('getUserInfo', JSON.stringify(res));
              const dic = this.$store.getters.getMemberInfo;
              that.$store.commit('setMemberInfo', { ...dic, ...res });
            });

          }
      }
    },
    androidMethod() {
      console.log("create count:", this.loadCount);
      if (window.hsj) {
        let _userInfo = getUserInfo();
        let _version = getAppVerInfo();
        console.log("android _userInfo", typeof _userInfo, _userInfo);
        console.log("android _version", typeof _version, _version);
        if (_version) {
          let info = JSON.parse(_userInfo);
          let ver = JSON.parse(_version);
          console.log("next app", info, ver);
          this.$store.commit("setMemberInfo", info);
          this.$store.commit("setQuery", info);
          this.$store.commit("setVer", ver); // "verCode":89,"verName":"1.6.2"
        }
        if (window.hsj.getMargins) {
          const marginInfo = window.hsj.getMargins();
          if (marginInfo) {
            this.setMargins(JSON.parse(marginInfo));
          }
        }
      } else {
        if (this.loadCount < 5) {
          setTimeout(() => {
            this.loadCount++;
            this.androidMethod();
            console.log("load times", this.loadCount);
          }, 200);
        }
      }
    },
    userInfoCb(_userInfo) {
      let info = JSON.parse(_userInfo);
      console.log("userInfoCb", info);
      this.$store.commit("setMemberInfo", info);
      this.$store.commit("setQuery", info);
      getBindInfo();
    },
    versionCb(_version) {
      console.log("versionCb org", _version);
      let ver = JSON.parse(_version);
      console.log("versionCb", ver);
      this.$store.commit("setVer", ver); // "verCode":89,"verName":"1.6.2"
    },
    setMargins(params) {
      setTimeout(() => {
        console.log('app setMargins', this.$route.name);
        // 仅对画世界Pro 用户指南生效
        if (this.$route.name === 'HsjProUsageGuide') {
          this.$refs.view?.$children[0]?.setMargins(params);
        }
      }, this.$route.name ? 0: 200);
      // console.log('app setMargins', this.$route.name);
      // // 仅对画世界Pro 用户指南生效
      // if (this.$route.name === 'HsjProUsageGuide') {
      //   this.$refs.view?.$children[0]?.setMargins(params);
      // }
      // 
      // const topMargin = params?.topMargin || 0;
      // const bottomMargin = params?.bottomMargin || 0;
      // document.documentElement.style?.setProperty('--safe-area-inset-top', `${topMargin / window.devicePixelRatio}px`);
      // document.documentElement.style?.setProperty('--safe-area-inset-bottom', `${bottomMargin / window.devicePixelRatio}px`);
      
      // document.querySelector('meta[name="viewport"]').setAttribute('content', "width=device-width,user-scalable=no,initial-scale=1.0,maximum-scale=1.0,minimum-scale=1.0,viewport-fit=cover");
    },
  },
};
</script>

<style>
</style>
